import {findTagsLikeNameAsync, postNoteAsync} from "./noteSlice";
import {useMsal} from "@azure/msal-react";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {useEffect, useState} from "react";
import {apiRequest, loginRequest} from "../../authConfig";
import {setActiveLink} from "../navmenu/navbarSlice";
import {Button, Col, Form, FormGroup, InputGroup, Row} from "react-bootstrap";
import {Formik} from 'formik';
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import {findCustomersLikeNameAsync} from "../customers/customersSlice";
import 'react-bootstrap-typeahead/css/Typeahead.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faX} from "@fortawesome/free-solid-svg-icons";
import MDEditor from '@uiw/react-md-editor';
import Switch from "react-switch";
import styles from './Notes.module.css';
import '../../index.css';
import {connect} from "react-redux";
import {useNavigate} from "react-router-dom";

export const AddNote = () => {
    const {instance, accounts} = useMsal();
    const dispatch = useAppDispatch();
    const customerLookup = useAppSelector((state) => state.customers.customerLookup);
    const tagLookup = useAppSelector((state) => state.note.tagLookup);
    const customerLookupLoading = useAppSelector((state) => state.customers.customerLookupStatus == 'loading');
    const tagLookupLoading = useAppSelector((state) => state.note.tagsLookupStatus == 'loading');
    const noteIsIdle = useAppSelector((state) => state.note.status === 'idle');
    const createdNoteId = useAppSelector(state => state.note.createdNoteId);
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(setActiveLink('/notes'));
    }, [dispatch]);
    
    useEffect(() => {
        if (createdNoteId && noteIsIdle) {
            navigate(`/notes/created/${createdNoteId}`);
        }
    }, [createdNoteId, noteIsIdle]);

    const shouldUpdateLookupSelection = (selection: any[]): boolean => {
        const target = selection[selection.length - 1];
        const selections = selection.filter(s => {
            return s?.name === target?.name;
        });

        return selections?.length <= 1;
    };

    const [customerSelections, setCustomerSelections] = useState<any[]>([]);
    const [tagSelections, setTagSelections] = useState<any[]>([]);
    const [markdownContent, setMarkdownContent] = useState<string | undefined>('');
    const [showRenderedMarkDown, setShowRenderedMarkDown] = useState<boolean>(false);

    const requestApiAccessToken = async (): Promise<string> => {
        const request = {
            ...apiRequest,
            account: accounts[0],
        };

        try {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        } catch (error) {
            const response = await instance.acquireTokenSilent(request);
            return response.accessToken;
        }
    };

    const handleCustomerSearch = async (query: string) => {
        const apiToken = await requestApiAccessToken();
        await dispatch(findCustomersLikeNameAsync({apiToken: apiToken, name: query}));
    };

    const handleTagSearch = async (query: string) => {
        const apiToken = await requestApiAccessToken();
        await dispatch(findTagsLikeNameAsync({
            apiToken: apiToken,
            name: query
        }));
    };
    
    const createNote = async ({archived, subject}
                                  : { archived: boolean, subject: string }) => {

        const apiToken = await requestApiAccessToken();

        await dispatch(postNoteAsync({
            data: {
                id: '',
                content: markdownContent,
                tags: tagSelections.map(t => t.name),
                archived: archived,
                subject: subject,
                customerIds: customerSelections.map(t => t.id),
                created: undefined,
                modified: undefined
            },
            apiToken: apiToken,
        }));
    };

    return (
        <Formik
            initialValues={{
                archived: false,
                subject: ''
            }}
            onSubmit={console.log}
            validate={values => {
                const errors: { [key: string]: any } = {};
                if (!values.subject) {
                    errors.subject = 'Required';
                }
                return errors;
            }}
            initialErrors={{subject: 'Required'}}
        >
            {({
                  handleChange,
                  values,
                  touched,
                  isValid,
                  errors,
                  resetForm,
                  validateField
              }) => (
                <Form>
                    <Row>
                        <Col className="col-12 col-lg-6 mb-2">
                            <Form.Group>
                                <Form.Label>Tag</Form.Label>
                                <InputGroup>
                                    <AsyncTypeahead
                                        newSelectionPrefix="Add new tag: "
                                        filterBy={() => true}
                                        id="searchTag"
                                        labelKey="name"
                                        isLoading={tagLookupLoading}
                                        minLength={1}
                                        onSearch={handleTagSearch}
                                        options={tagLookup}
                                        placeholder="Search for tags"
                                        selected={tagSelections}
                                        onChange={(v) => {
                                            if (shouldUpdateLookupSelection(v)) {
                                                setTagSelections(v);
                                            }
                                        }}
                                        multiple={true}
                                        allowNew={true}
                                    />
                                    <Button variant="secondary"
                                            onClick={() => {
                                                setTagSelections([]);
                                            }}
                                    >
                                        <FontAwesomeIcon icon={faX}/>
                                    </Button>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col className="col-12 col-lg-6 mb-2">
                            <Form.Group>
                                <Form.Label>Subject</Form.Label>
                                <InputGroup>
                                    <Form.Control
                                        id="subject"
                                        name="subject"
                                        type="text"
                                        value={values.subject}
                                        onChange={handleChange}
                                        isInvalid={!!errors.subject}
                                    />
                                    <Button variant="secondary"
                                            onClick={() => {
                                                resetForm({
                                                    values: {
                                                        archived: values.archived,
                                                        subject: ''
                                                    }
                                                });
                                            }}
                                    >
                                        <
                                            FontAwesomeIcon
                                            icon={faX}
                                        />
                                    </Button>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.subject}
                                    </Form.Control.Feedback>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col className="col-12 col-lg-6 mb-2">
                            <Form.Group>
                                <Form.Check type="checkbox">
                                    <Form.Check.Label>Archived</Form.Check.Label>
                                    <Form.Check.Input
                                        id="archived"
                                        checked={values.archived}
                                        type="checkbox"
                                        onChange={handleChange}/>
                                </Form.Check>
                            </Form.Group>
                        </Col>
                        <Col className="col-12 col-lg-6 mb-3">
                            <Form.Group>
                                <Form.Label>Customer</Form.Label>
                                <InputGroup>
                                    <AsyncTypeahead
                                        filterBy={() => true}
                                        id="searchCustomer"
                                        labelKey="name"
                                        isLoading={customerLookupLoading}
                                        minLength={1}
                                        onSearch={handleCustomerSearch}
                                        options={customerLookup}
                                        placeholder="Search for customers"
                                        selected={customerSelections}
                                        onChange={(v) => {
                                            if (shouldUpdateLookupSelection(v)) {
                                                setCustomerSelections(v);
                                            }
                                        }}
                                        multiple={true}
                                    />
                                    <Button variant="secondary"
                                            onClick={() => {
                                                setCustomerSelections([]);
                                                resetForm({
                                                    values: {
                                                        archived: values.archived,
                                                        subject: values.subject
                                                    }
                                                });
                                            }}
                                    >
                                        <FontAwesomeIcon icon={faX}/>
                                    </Button>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col className="col-12 mb-3">
                            <div className={styles.right}>
                                <FormGroup>
                                    <InputGroup>
                                        <Button
                                            disabled={!!errors.subject}
                                            onClick={() => createNote(values)}
                                        >
                                            Save
                                        </Button>
                                    </InputGroup>
                                </FormGroup>
                            </div>
                        </Col>
                        <Col className="col-12 mb-2">
                            <Form.Group>
                                <InputGroup className="col-12 mb-2">
                                    <MDEditor
                                        className="col-12 mb-2"
                                        value={markdownContent}
                                        onChange={setMarkdownContent}
                                        height={400}
                                    />
                                    <FormGroup className="col-xs-12">
                                        <InputGroup>
                                            <Switch
                                                checked={showRenderedMarkDown}
                                                onChange={setShowRenderedMarkDown}
                                                onColor="#0d6efd">
                                            </Switch>
                                            <Form.Label className={styles.labelMargin}>Show rendered
                                                markdown</Form.Label>
                                        </InputGroup>
                                    </FormGroup>
                                    {showRenderedMarkDown &&
                                        <MDEditor.Markdown
                                            className="col-12 mb-2"
                                            source={markdownContent}/>
                                    }
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            )
            }
        </Formik>
    );
};

export default connect()(AddNote);

// https://webtribunal.net/cdn-providers/#gref
// https://cdn.gcorelabs.com/resources/create/wizard
